//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwiperMixin from '~/mixins/swiper.mixin.js';
import ArrowIcon from '~/assets/svg/ic-arrow-right.svg?inline';

export default {
  components: {
    ArrowIcon,
  },
  mixins: [SwiperMixin],
  data() {
    return {
      slides: [
        {
          id: 1,
          img: require('~/assets/svg/Pen-tool-vector.svg'),
          title: 'about-us.areas.card-item-1.title',
          description: 'about-us.areas.card-item-1.description',
          countries: ['br', 'mx'],
        },
        {
          id: 2,
          img: require('~/assets/svg/Playlist.svg'),
          title: 'about-us.areas.card-item-2.title',
          description: 'about-us.areas.card-item-2.description',
          countries: ['br', 'mx'],
        },
        {
          id: 3,
          img: require('~/assets/svg/Chart-line#1.svg'),
          title: 'about-us.areas.card-item-3.title',
          description: 'about-us.areas.card-item-3.description',
          countries: ['br', 'mx'],
        },
        {
          id: 4,
          img: require('~/assets/svg/TV#1.svg'),
          title: 'about-us.areas.card-item-4.title',
          description: 'about-us.areas.card-item-4.description',
          countries: ['br', 'mx'],
        },
        {
          id: 5,
          img: require('~/assets/svg/Git#4.svg'),
          title: 'about-us.areas.card-item-5.title',
          description: 'about-us.areas.card-item-5.description',
          countries: ['br', 'mx'],
        },
        {
          id: 6,
          img: require('~/assets/svg/Combined Shape.svg'),
          title: 'about-us.areas.card-item-6.title',
          description: 'about-us.areas.card-item-6.description',
          countries: ['br', 'mx'],
        },
        {
          id: 7,
          img: require('~/assets/svg/briefcase.svg'),
          title: 'about-us.areas.card-item-7.title',
          description: 'about-us.areas.card-item-7.description',
          countries: ['br'],
        },
      ],
    };
  },
  mounted() {
    this.initSwiper();
  },
};
